/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/RecommendedArticles/theme';

export const RecommendedArticlesTheme = theme;
